class BlockColumnsNumber {
  constructor() {
    this._init();
  }

  _init() {
    const numbers = document.querySelectorAll('[data-number]');

    const inViewport = (entries, observer) => {
      entries.forEach((entry) => {
        // Assert entry.target as HTMLElement
        const targetElement = entry.target as HTMLElement;

        if (entry.isIntersecting) {
          // Check if it's not already animated or if you want to re-animate
          if (!(targetElement as any)._isAnimated) {
            // Assert as 'any' or define a custom type
            // console.log(
            //   `Element ${
            //     targetElement.id || targetElement.className
            //   } entered viewport. Delaying animation...`
            // );
            setTimeout(() => {
              animNum(targetElement);
            }, 300);
          }
        } else {
          if ((targetElement as any)._isAnimated) {
            // Assert as 'any'
            (targetElement as any)._isAnimated = false;
          }
        }
      });
    };

    numbers.forEach(function (number) {
      // Assert 'number' as HTMLElement when initializing
      const numElement = number as HTMLElement;
      (numElement as any)._isAnimated = false; // Assert as 'any' for the custom property
      const observer = new IntersectionObserver(inViewport);
      observer.observe(numElement);
    });

    function animNum(number: HTMLElement) {
      if ((number as any)._isAnimated) return;
      (number as any)._isAnimated = true;

      const countToAttr = number.getAttribute('data-number');
      if (countToAttr === null) {
        console.warn('Missing data-number attribute on element:', number);
        return;
      }

      const countTo = parseFloat(countToAttr);
      if (isNaN(countTo)) {
        console.warn('Invalid number in data-number attribute:', countToAttr);
        return;
      }

      animate(
        function (newValue) {
          let text: string;
          if (countTo % 1 === 0) text = Math.ceil(newValue).toString();
          else if ((countTo * 10) % 1 === 0) text = newValue.toFixed(1);
          else text = newValue.toFixed(2);
          number.innerHTML = numberWithSpaces(text);
        },
        0,
        countTo,
        3000,
        (x) => x
      );
    }

    function animate(
      render: (newValue: number) => void,
      from: number,
      to: number,
      duration: number,
      timeFx: (x: number) => number
    ) {
      let startTime = performance.now();
      requestAnimationFrame(function step(time) {
        let pTime = (time - startTime) / duration;
        if (pTime > 1) pTime = 1;
        render(from + (to - from) * timeFx(pTime));
        if (pTime < 1) {
          requestAnimationFrame(step);
        }
      });
    }

    function numberWithSpaces(x: number | string): string {
      // Add type for x
      let parts = x.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return parts.join('.');
    }
  }
}

export const blockColumnsNumber = new BlockColumnsNumber();
